import {Component, Output, EventEmitter, Input, OnInit} from '@angular/core';
import {IResourceSummaryComponent} from "../resources/resource-summary.component";
import {BrowserSessionService} from "../../services/browsersession.service";
import {WebmateEvent} from "../../types/base-types";
import {isDefined, produceCanonicalShortURL} from "../../utils/utils";
import {State} from '../../types/browsersession';
import {ArtifactService} from "../../services/artifact.service";
import {Subject, mergeMap} from "rxjs";
import {faQuestionCircle} from "@fortawesome/pro-light-svg-icons";
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';


@UntilDestroy()
@Component({
    selector: 'wm-statesummary',
    templateUrl: './statesummary.component.html',
    styleUrls: ['./statesummary.component.less']
})
export class StateSummaryComponent implements OnInit, IResourceSummaryComponent {

    resourceType: string; // BrowserSessionStateId
    viewType: string;
    @Input() resourceId: string;
    projectId: string;
    params: any;

    @Input() issues?: Map<string, number> = undefined;

    @Input() isLoaded: boolean = false;

    @Input() highlighted: boolean = false;

    @Input() customLabel?: string;

    @Input() nonInteractive: boolean = false;

    @Output() genericEvent = new EventEmitter<WebmateEvent>();

    state: State;
    urlToDisplay?: string = undefined;
    issueCount?: number = undefined;
    hardError: boolean = false;
    noScreenshot: boolean = false;

    wantRefresh$ = new Subject<boolean>();

    constructor(private browserSessionService: BrowserSessionService, private artifactService: ArtifactService) {}


    ngOnInit() {
        this.wantRefresh$.pipe(mergeMap(forceRefresh => this.browserSessionService.getState$(this.resourceId, forceRefresh))).pipe(untilDestroyed(this)).subscribe(state => {
            this.state = state;
            this.update();
        });
        this.wantRefresh$.next(true);
    }

    ngOnChanges() {
        this.wantRefresh$.next(false);
    }

    private update() {
        this.issueCount = undefined;
        if (isDefined(this.state) && !this.state.isMockState()) {
            this.urlToDisplay = produceCanonicalShortURL(this.state.description);
            this.noScreenshot = !(this.state.firstScreenshotThumbnailUrl || this.state.firstScreenshotUrl);

            // TODO: implement screenshot waiting logic.. see labs branch for (bad) idea
            if (this.state.associatedArtifacts.length > 0) {
                this.hardError = false;
                if (isDefined(this.issues)) {
                    this.issueCount = this.state.associatedArtifacts
                        .map(artifact => this.issues.get(artifact.id) || 0)
                        .reduce((prev, curr) => (prev || 0) + (curr || 0), 0);
                }
            } else {
                if (isDefined(this.issues)) {
                    this.issueCount = 0;
                }
                this.urlToDisplay = "";
                this.hardError = false;
            }
        } else this.hardError = true;
    }

    stateSummaryClicked() {
        if (!this.hardError && !this.nonInteractive) {
            this.genericEvent.emit(new WebmateEvent("StateSummaryComponent", "StateSummary.Clicked", this.state.id));
        }
    }

    protected readonly faQuestionCircle = faQuestionCircle;
}
